import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseUrl } from '../../baseUrl'
import { Link, useParams } from 'react-router-dom'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const StudentEdit = () => {
    const params=useParams()
    const [message, setMessage] = useState(false)
    const [name, setName] = useState("")
    const [contact,setContact]=useState('')
    const [email, setEmail] = useState("")
    const [dob, setDOB] = useState('')
    const [gender, setGender] = useState('')
    const [fatherName, setFatherName] = useState('')
    const [motherName, setMotherName] = useState('')
    const [category, setCategory] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const data={name,email,contact,dob,gender,fatherName,motherName,category,password}

    useEffect(()=>{
        axios.get(`${baseUrl}/student/get-by-email/?email=${params.email}`)
        .then(res=>{
            setName(res.data.name)
            setEmail(res.data.email)
            setContact(res.data.contact)
            setDOB(res.data.dob)
            setGender(res.data.gender)
            setFatherName(res.data.fatherName)
            setMotherName(res.data.motherName)
            setCategory(res.data.category)
            setPassword(res.data.password)
            setConfirmPassword(res.data.password)
    
        })
        .catch(err=>console.log(err))
      },[]
    )
    const handleSubmit = (e) => {
        if(password!==confirmPassword){
          setMessage('Please enter Confirm password same as Password')
        }
        else if(name===""||email===""||contact===""||dob===''||gender===''||fatherName===''||motherName===''||
          category===''
        ){
          setMessage('Make sure you enter all required details')
        }
        else{
          axios
          .post(`${baseUrl}/student/update-by-email/?emailID=${params.email}`, data)
          .then((res) => {
            if (res.data === "success") {
              setMessage("Profile updated successfully");
            }
            if (res.data === "failed") {
              setMessage("Something went wrong");
            }
          })
          .catch((err) => console.log(err));
        }
      };
    return (
        <div>
            <div
                className="container"
                style={{ backgroundColor: "#F3F8FB", padding: "40px" }}
            >
                <div className="bg-white p-4">
                    <Link to={`/student/${params.email}`} className='text-dark mb-1'><KeyboardBackspaceIcon fontSize='large'/></Link>
                    <h4>Edit Student</h4>
                    <div className="row mb-3">
                        <div className="col-lg-6">
                            <label htmlFor="name" className="form-label">
                                Student Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Enter Name"
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                            />
                        </div>
                        <div className="col-lg-6">
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                placeholder="Enter Email"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-lg-6">
                            <label htmlFor="dob" className="form-label">
                                Date of Birth
                            </label>
                            <input id='dob' value={dob} type='date' className="form-control" onChange={(e) => setDOB(e.target.value)} />
                        </div>
                        <div className="col-lg-6">
                            <label htmlFor="gender" className="form-label">
                                Gender
                            </label>
                            <select value={gender} onChange={(e) => setGender(e.target.value)} className="form-select" id="gender" aria-label="Default select example">
                                <option hidden>Select Gender</option>
                                <option value='male'>
                                    Male
                                </option>
                                <option value='female'>
                                    Female
                                </option>
                                <option value='other'>
                                    Other
                                </option>
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-lg-6">
                            <label htmlFor="fatherName" className="form-label">
                                Father Name
                            </label>
                            <input
                                value={fatherName}
                                type="text"
                                className="form-control"
                                id="fatherName"
                                placeholder="Enter Father Name"
                                onChange={(e) => setFatherName(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-6">
                            <label htmlFor="motherName" className="form-label">
                                Mother Name
                            </label>
                            <input
                                value={motherName}
                                type="text"
                                className="form-control"
                                id="motherName"
                                placeholder="Enter Mother name"
                                onChange={(e) => setMotherName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-lg-6">
                            <label htmlFor="category" className="form-label">
                                Category
                            </label>
                            <select value={category} onChange={(e) => setCategory(e.target.value)} className="form-select" id="category" aria-label="Default select example">
                                <option hidden>Select category</option>
                                <option>
                                    General
                                </option>
                                <option>
                                    OBC
                                </option>
                                <option>
                                    SC
                                </option>
                                <option>
                                    ST
                                </option>
                            </select>
                        </div>
                        <div className="col-lg-6">
                        <label htmlFor="contact" className="form-label">
                                Contact
                            </label>
                        <input
                                value={contact}
                                type="number"
                                className="form-control"
                                id="contact"
                                placeholder="Enter contact"
                                onChange={(e) => setContact(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-lg-6">
                            <label htmlFor="password" className="form-label">
                                Password
                            </label>
                            <input
                                value={password}
                                type="password"
                                className="form-control"
                                id="password"
                                placeholder="Enter password"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-6">
                            <label htmlFor="confirmPassword" className="form-label">
                                Confirm Password
                            </label>
                            <input
                                value={confirmPassword}
                                type="password"
                                className="form-control"
                                id="confirmPassword"
                                placeholder="Reenter password"
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </div>
                    </div>
                    {message && (
                        <div
                            className="alert alert-warning alert-dismissible fade show mt-3"
                            role="alert"
                        >
                            {message}
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                onClick={() => setMessage(false)}
                            ></button>
                        </div>
                    )}
                    <button onClick={handleSubmit} className="btn btn-primary mt-4">
                        Update
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StudentEdit
